/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

	// COMPONENT
		// vx-autosuggest
	// starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return "xl"
    else if (state.windowWidth >= 992) return "lg"
    else if (state.windowWidth >= 768) return "md"
    else if (state.windowWidth >= 576) return "sm"
    else return "xs"
  },

  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },
  appActiveUserROle: state => state.AppActiveUser !== null ? state.AppActiveUser.userRole : '',
  appActiveUser: state => state.AppActiveUser,
  loading: state => state.loading,
  error: state => state.error !== null ? state.error.detail : '',
  accessToken: state => state.accessToken,
  refreshToken: state => state.refreshToken,
  adminUser: state => state.allUser.filter(user => user.role === 'ADMIN'),
  reviewUser: state => state.allUser.filter(user => user.role === 'REVIEW'),
  viewOnlyUser: state => state.allUser.filter(user => user.role === 'VIEW_ONLY'),
  aUser: (state) => (userID) => {
    return state.allUser.find(user => user.user_id === userID)
  },
  viewOnlyUserACL: state => state.viewOnlyUserACL,
  viewOnlyUserACLFootfall: state => state.viewOnlyUserACLFootfall,
  viewOnlyUserACLAnalytis: state => state.viewOnlyUserACLAnalytics,
  downloadAnalytics: state => state.analyticDownload,
  showrooms: state => state.showrooms,
  aShowroom: (state) => (suffix) => {
    return state.showrooms.find(showroom => showroom.suffix === suffix)
  },
  link: state => state.link,
  meta: state => state.meta,
  applicantList: state => state.applicantList,
  applicant: state => state.applicant,
  gaurantorList: state => state.gaurantorList,
  gaurantor: state => state.gaurantor,
  applicationList: state => state.applicationList,
  application: state => state.application,
  productMasterList: state => state.productMasterList,
  dashboardDataList: state => state.dashboardData,
  applicationGuarantor: state => state.application.data.guarantors,
  aApplicationCount: (state) => (status) => {
    return state.dashboardData.application.find(app => app.status === status)
  },
  washingMachineTrailList: state => state.washingMachineTrail,
  wmTrailDetailById: state => state.wmTrailDetailById,
  compareData: state => state.compareData,
  excelSearch: state => state.excelSearch,
  profileList: state => state.profileList,
  profileDetails: state => state.profileDetails,
  excelUploadLoad: state => state.uploadExcelLoad,
  excelCompareLoad: state => state.compareExcelLoad,
  uploadExcelDone: state => state.uploadExcelDone,
  compareExcelDone: state => state.compareExcelDone,
  allChangeReqAppl: state => state.changeReqApplList,
  applicantProPersonalUpdateList: state => state.applicantPersonalProfileUpdate,
  blockedApplByValidateStatus: state => state.blockedApplicationList,
}

export default getters
